export default "__VITE_ASSET__CI4s9H88__"